import React, {useContext} from "react";
import "./Skills.scss";
import {illustration, skillsSection} from "../../portfolio";
import { motion } from "framer-motion";
import codingPerson from "../../assets/lottie/Coding";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

export default function Skills() {
  const {isDark} = useContext(StyleContext);
  if (!skillsSection.display) {
    return null;
  }

  return (
    <div
      className={`${isDark ? "dark-mode main" : "main"} content-rail`}
      id="skills"
    >

    <div className={isDark ? "dark-mode main" : "main"} id="skills" >
      <div className="skills-main-div" >
        <motion.div
          initial={{ opacity: 0, x: -200 }}  // move in from left
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}      // 1000ms = 1s
        >
          <div
            className="skills-image-div"

          >
            {illustration.animated ? (
              <DisplayLottie animationData={codingPerson}  />
            ) : (
              <img
                alt="Man Working"
                src={require("../../assets/images/developerActivity.svg")}

              />
            )}
          </div>
        </motion.div>


        <motion.div
          initial={{ opacity: 0, x: 40 }}   // enter from right
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}      // 1000ms = 1s
        >
          <div className="skills-text-div">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}

            >
              {skillsSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle skills-text-subtitle"
                  : "subTitle skills-text-subtitle"
              }
            >
              {skillsSection.subTitle}
            </p>
            {skillsSection.skills.map((skillGroup, i) => (
              <div key={i} className="skill-group">
                <h3
                  className={isDark ? "dark-mode skill-title" : "skill-title"}
                >
                  {skillGroup.title}
                </h3>
                <div
                  className={
                    isDark ? "dark-mode skill-desc-wrapper" : "skill-desc-wrapper"
                  }

                >
                  <p className="skill-desc">{skillGroup.skillList}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
    </div>
  );
}
